/**
 * As abas da tela de Contratos (`TP-067`, `D3`). Fontes abre por padrão: é onde está o PDF e a situação de cada
 * leitura. A aba vai para a URL (`?aba=`), para o link levar direto a ela — mesmo padrão das abas do Caso.
 */
export const ABAS_DO_CONTRATO = [
  { chave: 'fontes', rotulo: 'Fontes' },
  { chave: 'regras', rotulo: 'Regras' },
  { chave: 'clausulas', rotulo: 'Cláusulas' },
  { chave: 'itens', rotulo: 'Itens' },
] as const;

export type AbaDoContrato = (typeof ABAS_DO_CONTRATO)[number]['chave'];

export function lerAbaDoContrato(valor: string | null): AbaDoContrato {
  return ABAS_DO_CONTRATO.find((a) => a.chave === valor)?.chave ?? 'fontes';
}
